module.exports = __webpack_public_path__ + "static/solomons-mid-city-autos-140aee6bf1692825c925e1ce9b3686fe.jpg";